export default __webpack_public_path__ + "static/media/5.INFORMES_SFS.400ae642.mp4";